import { AnimatedProgressBar } from "../ui/animated-progress-bar";

export const MarkdownSkeleton = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="w-1/2">
        <AnimatedProgressBar progress={95} duration={2000} />
      </div>
    </div>
  );
};

